module.exports = __webpack_public_path__ + "static/media/discover.304d684c.svg";